
import { useTranslation } from 'react-i18next';

const IntroSection = () => {
  const { t } = useTranslation('partnership');

  return (
    <section className="py-8 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <span className="text-gold-600 font-semibold text-[10px] md:text-sm uppercase tracking-wider">{t('intro.title')}</span>
            <h2 className="text-lg md:text-3xl lg:text-4xl font-bold text-gray-900 mt-2 md:mt-3 mb-2 md:mb-6 font-serif leading-snug">
              {t('intro.heading')}
            </h2>
            <p className="text-xs md:text-base text-gray-600 mb-2 md:mb-6 leading-relaxed">
              {t('intro.description1')}
            </p>
            <p className="text-xs md:text-base text-gray-600 mb-4 md:mb-8 leading-relaxed">
              {t('intro.description2')}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
              <div className="flex items-start">
                <div className="w-8 h-8 md:w-12 md:h-12 flex items-center justify-center bg-gold-100 rounded-lg mr-2.5 md:mr-4 flex-shrink-0">
                  <i className="ri-hand-coin-line text-sm md:text-xl text-gold-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-0.5 md:mb-1 text-xs md:text-base">{t('benefits.items.0.title')}</h4>
                  <p className="text-gray-600 text-[10px] md:text-sm">{t('benefits.items.0.description')}</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-8 h-8 md:w-12 md:h-12 flex items-center justify-center bg-gold-100 rounded-lg mr-2.5 md:mr-4 flex-shrink-0">
                  <i className="ri-customer-service-2-line text-sm md:text-xl text-gold-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-0.5 md:mb-1 text-xs md:text-base">{t('benefits.items.1.title')}</h4>
                  <p className="text-gray-600 text-[10px] md:text-sm">{t('benefits.items.1.description')}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative order-1 lg:order-2">
            <div className="relative rounded-xl md:rounded-2xl overflow-hidden shadow-xl md:shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/bc75aef280e3ea5425037c1a4bef8a3f.jpg"
                alt="Business Partnership"
                className="w-full h-48 md:h-96 object-cover object-top"
              />
              <div className="absolute top-4 right-4 md:top-6 md:right-6 bg-white/95 backdrop-blur-sm rounded-lg md:rounded-xl px-3 py-2 md:px-4 md:py-3 shadow-lg hidden md:block">
                <div className="flex items-center">
                  <i className="ri-award-line text-xl md:text-2xl text-gold-600 mr-2 md:mr-3"></i>
                  <div>
                    <div className="text-xs md:text-sm text-gray-500">{t('intro.badge')}</div>
                    <div className="text-base md:text-lg font-bold text-gray-900">{t('intro.badgeValue')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
